import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 3.5C9.41421 3.5 9.75 3.83579 9.75 4.25V8.75H14.25C14.6642 8.75 15 9.08579 15 9.5C15 9.91422 14.6642 10.25 14.25 10.25H9.75V14.75C9.75 15.1642 9.41421 15.5 9 15.5C8.58579 15.5 8.25 15.1642 8.25 14.75V10.25H3.75C3.33579 10.25 3 9.91422 3 9.5C3 9.08579 3.33579 8.75 3.75 8.75H8.25V4.25C8.25 3.83579 8.58579 3.5 9 3.5Z", fill: "white" }));
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
